/**
 * Dictionary of component/verb keys mapped to static text displayed as section
 * titles. This lets us consolidate and reuse static text from a single location
 * instead of duplicating them across different components.
 */
export default {
  activityHome: 'Activities',
  activityCreator: 'Choose an activity',
  activityFlow: 'Activity flow',
  activityModerator: 'Moderator',
  activitySearch: 'Search',
  activityTrash: 'Trash',
  activityEditor: 'Edit activity',
  groupEditor: 'Edit folder',
  groupSelector: {
    bulkMove: 'Select the destination folder',
    bulkCopy: 'Select the destination folder'
  },
  registrationsHome: 'Registrations',
  reorderActivities: 'Change activity order',
  reportChange: {
    activityList: 'Change activities',
    groupSelection: 'Select a folder',
    activitySelection: 'Select activities'
  },
  reportEditor: 'Edit report',
  reportHome: 'Reports',
  reportType: 'Choose a report type',
  settingsManager: 'Settings',
  feedback: 'Send product feedback',
  optOutFeedback: 'Send opt-out feedback'
}
